// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wo_a bib_b"};